import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './test.module.scss';
import {
  Heading2,
  Title,
  SubTitle,
  SecondaryText,
  Button,
  Heading4
} from '../../../../landingComponents/typography';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import { getClassName } from 'src/Core/utility/jsx';
import LandingButton from 'src/components/landingComponents/button';
import { TestDescription } from './oak';

const Biochemistry = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <Heading4 className={styles.header} accent>
        Общая биохимия крови
      </Heading4>
      <InfoBlock />
      <div className={styles.bottom}>
        <SubTitle accent>
          Этот анализ дает важную информацию о состоянии вашего обмена веществ и
          помогает своевременно обнаружить возможные нарушения в работе
          внутренних органов.
        </SubTitle>
        <LandingButton variant="contained" href="/questions">
          <Button>Загрузить анализы</Button>
        </LandingButton>
      </div>
    </CommonLandingContainer>
  );
};

export default Biochemistry;

const InfoBlock = () => {
  return (
    <AnimatedBox className={getClassName([styles.right])}>
      <div className={styles.rightText}>
        <Title accent>
          Биохимический анализ крови, который включает такие важные параметры,
          как:
        </Title>
        <div className={styles.infoText}>
          <TestDescription
            accentText="Липопротеиды, "
            text=" в том числе холестерин — помогают оценить риски развития атеросклероза."
          ></TestDescription>
          <TestDescription
            accentText="Глюкоза и гликированный гемоглобин "
            text=" — ключевые показатели для оценки риска сахарного диабета."
          ></TestDescription>
          <TestDescription
            accentText="Ферменты "
            text=" печени, поджелудочной железы, сердца — такие как АлаТ, АсаТ, ЛДГ, КФК, которые позволяют выявить повреждения соответствующих органов."
          ></TestDescription>
        </div>
      </div>
    </AnimatedBox>
  );
};